/* eslint-disable indent */
import React from "react";
import SelectInput2 from "../../../component/input/SelectInput2";
import TextInput2 from "../../../component/input/TextInput2";
import Button from "../../../component/button/Button";
import {
  renderLocationFunction,
  renderReportingMangersFunction
} from "../../../constant/helper/helper";
import PropTypes from "prop-types";

const TopInputs = ({
  values,
  onSubmit,
  locations,
  currentUser,
  foundManagers,
  handleInputChange
}) => {
  return (
    <div className="row">
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
        <TextInput2
          data-tip
          type="date"
          name="fromDate"
          data-for="fromDate"
          value={values.fromDate}
          placeholder="Select From Date"
          onChange={handleInputChange}
          icon="mdi mdi-calendar-check"
        />
      </div>
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
        <TextInput2
          data-tip
          type="date"
          name="toDate"
          data-for="toDate"
          value={values.toDate}
          placeholder="Select To Date"
          onChange={handleInputChange}
          icon="mdi mdi-calendar-check"
        />
      </div>
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
        {currentUser.workerDepartment === "SUPER ADMIN" &&
        currentUser.workerDesignation === "SUPER ADMIN" ? (
          <SelectInput2
            data-tip
            isLabeled={true}
            name="locationId"
            data-for="locationId"
            label="Select Location"
            value={values.locationId}
            onChange={handleInputChange}
            placeholder="Select Location"
            icon="mdi mdi-map-marker-radius"
          >
            {renderLocationFunction(locations)}
          </SelectInput2>
        ) : (
          <TextInput2
            data-tip
            type="text"
            name="text"
            readonly={true}
            data-for="locationId"
            placeholder="Location"
            icon="mdi mdi-map-marker-radius"
            value={localStorage.locationName}
          />
        )}
      </div>
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
        <SelectInput2
          data-tip
          name="reportingMangerId"
          isLabeled={true}
          data-for="reportingMangerId"
          label="Select Manager"
          icon="mdi mdi-contacts"
          value={values.reportingMangerId}
          onChange={handleInputChange}
          placeholder="Select Manager"
        >
          {renderReportingMangersFunction(foundManagers)}
        </SelectInput2>
      </div>
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
        <SelectInput2
          data-tip
          name="sendMail"
          isLabeled={false}
          data-for="sendMail"
          label="Mail / No Mail"
          icon="mdi mdi-contacts"
          value={values.sendMail}
          onChange={handleInputChange}
          placeholder="Mail / No Mail"
        >
          <option value={false}>Do not send mail</option>
          <option value={true}>Send mail</option>
        </SelectInput2>
      </div>
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
        <SelectInput2
          data-tip
          isLabeled={false}
          name="convertByTime"
          label="By Time / By AB,P"
          icon="mdi mdi-contacts"
          data-for="convertByTime"
          value={values.convertByTime}
          onChange={handleInputChange}
          placeholder="By Time / By AB,P"
        >
          <option value={false}>By AB/P</option>
          <option value={true}>By Time</option>
        </SelectInput2>
      </div>
      <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12">
        <div className="form-group">
          <Button
            type="button"
            onClick={onSubmit}
            title="GET"
            isBackgroundColor={false}
            icon="mdi mdi-plus-circle-outline mr-2"
            className="btn mb-2 text-white btn-dark btn-block"
          />
        </div>
      </div>
    </div>
  );
};

TopInputs.propTypes = {
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  locations: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  foundManagers: PropTypes.array.isRequired,
  handleInputChange: PropTypes.func.isRequired
};

export default TopInputs;
